











































































































































































































































































































































































































import * as R from 'ramda';
import { v4 as uuidv4 } from 'uuid';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { EventTriggerType, Language, _Boolean } from '@/API';
import { JobItem } from '@/appsync/graphql/job';
import { executeJobImmediately } from '@/appsync/lambda/jobExecuteService';
import { getImportJobStatus } from '@/appsync/lambda/lambdaExecutionStatusService';
import {
  generateUploadLink,
  uploadFilesToIFXAP,
} from '@/appsync/lambda/uploadFileViaConversionApiService';
import { fetchLatestCustomerCompanyVersion } from '@/appsync/service/CustomerCompanyVersionService';
import { fetchJobs } from '@/appsync/service/JobQueryService';
import { getIsPortalEnabledStatus } from '@/appsync/service/SystemSettingQueryService';
import { fetchLatestTaskMetadatas } from '@/appsync/service/TaskMetadataQueryService';
import { TextRuleType } from '@/components/atoms/neon/CustomTextField.vue';
import ExportJobFileDialog from '@/components/organisms/ExportJobFileDialog.vue';
import ImportJobFileDialog from '@/components/organisms/ImportJobFileDialog.vue';
import TaskList from '@/components/organisms/TaskList.vue';
import TaskListItem from '@/components/organisms/TaskListItem.vue';
import UploadOnExecuteDialog from '@/components/organisms/UploadOnExecuteDialog.vue';
import WarningOnAccessFromIosDialog from '@/components/organisms/WarningOnAccessFromIosDialog.vue';
import { BusEvent, BusEventTargets } from '@/containers/globals/BusEvent';
import { refreshStores } from '@/containers/globals/globalSharedService';
import PageNotFound from '@/containers/pages/PageNotFound.vue';
import ErrorMessagePageTemplate from '@/containers/templates/ErrorMessagePageTemplate.vue';
import PortalAppBar from '@/containers/templates/PortalAppBar.vue';
import { i18n } from '@/plugins/i18n/i18n';
import router from '@/router';
import { commonModule } from '@/store/modules/CommonStore';
import { globalSnackbarModule } from '@/store/modules/GlobalSnackbarStore';
import { loginUserModule } from '@/store/modules/LoginUserStore';
import {
  LoginInfo,
  TaskItemForDB,
  TaskMetadataItemForFront,
  UploadFilesData,
  UserInfo,
  JobLocationWithNameAndParams,
} from '@/types/type';
import {
  getDisabledRoutes,
  getSHA3OfTenantLandscape,
  isAccessedFromIosDeviceOrSafariBrowser,
  isNotEmptyArray,
  isNotEmptyString,
  joinWithHash,
  _BooleanEnum2boolean,
  isAllUnique,
} from '@/utils/CommonUtils';
import {
  callCreateJob,
  callUpdateJob,
  generateJobItem,
  getSortedFilteredJobs,
  getMergeTaskAndMetadata,
  getArrayOfOutputFilePath,
} from '@/utils/JobUtils';
import {
  PAGE_PATH_BY_NAME,
  SNACKBAR_TIMEOUT,
  ImportJobStatus,
} from '@/utils/consts';

@Component({
  components: {
    ErrorMessagePageTemplate,
    PageNotFound,
    PortalAppBar,
    TaskList,
    TaskListItem,
    UploadOnExecuteDialog,
    WarningOnAccessFromIosDialog,
    ImportJobFileDialog,
    ExportJobFileDialog,
  },
})
export default class Jobs extends Vue {
  private loading: boolean = true;

  private loginInfo!: LoginInfo;

  private isJobSchedulerEnabled: boolean = false;

  private notEnabledImgAltMessage: String = 'Page Not Enabled';

  private notEnabledImgName: String = 'page-not-enabled';

  private notEnabledImgWidth: String = '250px';

  private notEnabledImgHeight: String = '186px';

  private jobCode: string = '';

  private jobTitle: string = '';

  private jobDescription: string = '';

  private jobTriggerFilePath: string = '';

  private jobId: string = '';

  private version!: string;

  private searchWord = '';

  private showJobDetailArea: boolean = false;

  private showingConfirmationDialog: boolean = false;

  private showImportJobFileDialog: boolean = false;
  private showExportJobFileDialog: boolean = false;

  private doUploadOnExecuteOrNotDialog: boolean = false;

  private jobExecutedDialog: boolean = false;

  private addedTasks: TaskItemForDB[] = [];

  private allTaskMetadatas!: TaskMetadataItemForFront[];

  private jobs: JobItem[] = [];

  private isSaved: boolean = false;

  private isCopied: boolean = false;

  private draggingItemIndex: number | null = null;

  private selectedJob!: JobItem | null | undefined;

  private nextUrl: JobLocationWithNameAndParams = this.initializeJobLocationWithNameAndParams();

  private hasJobSchedulerPermission: boolean = false;

  private isPortalEnabled: boolean = false;

  private duplicateOutputPathExist: boolean = false;

  private jobIdNotFound: boolean = false;

  private snackbarTimeout: number = SNACKBAR_TIMEOUT;

  private ruleInputRequired = i18n.tc('portal.ruleInputRequired');
  private ruleInputUnique = i18n.tc('portal.ruleInputUnique');
  private ruleInputAlphanumericFormat = i18n.tc(
    'portal.ruleInputAlphanumericFormat'
  );
  private ruleInputRegExpCompilable = i18n.tc(
    'portal.ruleInputRegExpCompilable'
  );

  private uploadingOverlay = false;
  private executingOverlay = false;
  private eventCalendarPath = PAGE_PATH_BY_NAME.eventCalendar;

  private startFromTheFirstTask: number = 0;
  private showAccessFromIosOrSafariWarningDialog: boolean = false;

  private addTask() {
    const order = this.addedTasks.length;
    this.addedTasks.push({
      version: '',
      product: '',
      batch: '',
      batchName: '',
      versionProductBatch: '',
      jobId: this.jobId,
      order,
      jobIdOrder: joinWithHash(this.jobId, order.toString()),
      taskMetadata: null,
      title: '',
      args: [],
      includeInDownload: _Boolean._true,
    });
  }

  public async created(): Promise<void> {
    this.loginInfo = commonModule.loginInfo;
    await refreshStores(this.loginInfo);
    this.hasJobSchedulerPermission = (this as any).$hasPermission('menus.job');

    this.isPortalEnabled = await getIsPortalEnabledStatus(
      this.loginInfo.tenant,
      this.loginInfo.landscape
    );

    const disabledRoutes = await getDisabledRoutes(
      this.loginInfo.tenant,
      this.loginInfo.landscape,
      this.loginInfo.loginName
    );

    if (!disabledRoutes.includes(PAGE_PATH_BY_NAME.jobs)) {
      this.isJobSchedulerEnabled = true;

      const isAccessedFromNotRecommendedEnv: boolean = isAccessedFromIosDeviceOrSafariBrowser();
      if (isAccessedFromNotRecommendedEnv) {
        this.showAccessFromIosOrSafariWarningDialog = true;
      }

      this.jobs = await fetchJobs(
        this.loginInfo.tenant,
        this.loginInfo.landscape
      );

      this.version =
        (await fetchLatestCustomerCompanyVersion(
          getSHA3OfTenantLandscape(
            this.loginInfo.tenant,
            this.loginInfo.landscape
          )
        )) || '';
      this.allTaskMetadatas = await fetchLatestTaskMetadatas(this.version);

      const jobId: string | null = this.$route.params.id as string | null;
      if (jobId) {
        this.jobId = jobId;
        this.selectedJob = R.find(R.propEq('id', this.jobId), this.jobs);
        if (this.selectedJob && !R.includes('create')(this.$route.fullPath)) {
          this.copyDbDataToCurrentData();
          this.showJobDetailArea = true;
        } else {
          if (R.includes('create')(this.$route.fullPath)) {
            this.jobId = uuidv4();
            router.push({
              name: 'createJob',
              params: { id: this.jobId },
            });
            this.showJobDetailArea = true;
          } else {
            this.jobIdNotFound = true;
          }
        }
      }
    }
    this.loading = false;
  }

  private async fetchJobData() {
    const fetchedJobs: JobItem[] = await fetchJobs(
      this.loginInfo.tenant,
      this.loginInfo.landscape
    );
    if (!R.equals(fetchedJobs, this.jobs)) {
      this.jobs = fetchedJobs;
    }
  }

  private rules: { [key: string]: TextRuleType } = {
    required: value => !!value || this.ruleInputRequired,
  };

  private get isEditMode() {
    return this.$route.name !== 'createJob';
  }

  private jobCodeRequiredRule(value: string) {
    return !!value || this.ruleInputRequired;
  }

  private jobCodeUniqueRule(value: string) {
    const isDuplicate = !this.jobs.some(({ jobCode }) => value === jobCode);
    return isDuplicate || this.ruleInputUnique;
  }

  private jobCodeFormatRule(value: string) {
    const regex = /^[a-zA-Z0-9_]+$/;
    return regex.test(value) || this.ruleInputAlphanumericFormat;
  }

  private get jobCodeRules() {
    if (this.isEditMode) return [];
    return [
      this.jobCodeRequiredRule,
      this.jobCodeUniqueRule,
      this.jobCodeFormatRule,
    ];
  }

  private regExpCompilable(value: string) {
    try {
      new RegExp(value);
      return true;
    } catch (e) {
      return this.ruleInputRegExpCompilable;
    }
  }

  private get fileTriggerPathRules() {
    return [this.regExpCompilable];
  }

  private get noJobSelectedImg(): string {
    const imgName = 'no-job-selected';
    const images = require.context('../../assets/', false, /\.svg$/);

    const locale = i18n.locale as Language;
    switch (locale) {
      case Language.ja:
        return images(`./${imgName}-ja.svg`);
      case Language.en:
        return images(`./${imgName}-en.svg`);
      default: {
        return images(`./${imgName}-ja.svg`);
      }
    }
  }

  private copyJobCode() {
    if (this.jobCode) {
      navigator.clipboard.writeText(this.jobCode);
      this.isCopied = true;
    }
  }

  private updateTaskOrder(updatedTasks: any[]) {
    this.addedTasks = updatedTasks;
  }

  private onClickJobFromJobList(nextJobId: string) {
    if (!this.doesAnyChangeExists()) {
      if (this.jobId !== nextJobId) {
        this.jobId = nextJobId;
        this.selectedJob = R.find(R.propEq('id', this.jobId), this.jobs);
        this.copyDbDataToCurrentData();
        router.push({
          name: 'job',
          params: { id: this.jobId },
        });
      }
      this.showJobDetailArea = true;
    } else {
      this.nextUrl = {
        name: 'job',
        params: { id: nextJobId },
      };
      this.showingConfirmationDialog = true;
    }
  }

  @Watch('jobs')
  private sortedFilteredJobs(): JobItem[] {
    return getSortedFilteredJobs(this.searchWord, this.jobs);
  }

  @Watch('jobs')
  private hasJobs(): boolean {
    return isNotEmptyArray(this.sortedFilteredJobs());
  }

  private get userInfo(): UserInfo {
    return loginUserModule.userInfo;
  }

  private get newJobLabel(): string {
    return R.ifElse(
      R.includes('create'),
      R.always(i18n.tc('jobScheduler.jobs.newJob')),
      R.always('')
    )(this.$route.fullPath);
  }

  private addNewJob() {
    const newJobId = uuidv4();
    const nextUrl = {
      name: 'createJob',
      params: { id: newJobId },
    };
    if (!this.doesAnyChangeExists()) {
      this.jobId = newJobId;
      router.push(nextUrl);
      this.emptyJobData();
      this.showJobDetailArea = true;
      if (this.$refs.jobTitle) {
        (this.$refs as any).jobTitle.resetValidation();
      }
      if (this.$refs.jobCode) {
        (this.$refs as any).jobCode.resetValidation();
      }
      this.selectedJob = null;
    } else {
      this.nextUrl = nextUrl;
      this.showingConfirmationDialog = true;
    }
  }

  private onClickOkInDialog() {
    if (this.nextUrl.name === 'jobs') {
      this.jobId = '';
      this.selectedJob = null;
      this.showJobDetailArea = false;
    } else if (this.nextUrl.name === 'createJob') {
      this.jobId = R.defaultTo('', this.nextUrl.params.id);
      this.selectedJob = null;
      this.showJobDetailArea = true;
      (this.$refs as any).jobTitle.resetValidation();
      (this.$refs as any).jobCode.resetValidation();
    } else if (this.jobId !== R.defaultTo('', this.nextUrl.params.id)) {
      this.jobId = R.defaultTo('', this.nextUrl.params.id);
      this.selectedJob = R.find(R.propEq('id', this.jobId), this.jobs);
      this.showJobDetailArea = true;
    }
    this.copyDbDataToCurrentData();
    router.push(this.nextUrl);
    this.nextUrl = this.initializeJobLocationWithNameAndParams();
    this.showingConfirmationDialog = false;
  }

  @Watch('isSaved')
  private canExecute() {
    return Boolean(
      this.jobTitle && this.addedTasks.length > 0 && !this.doesAnyChangeExists()
    );
  }

  private onClickCancelInDialog() {
    this.nextUrl = this.initializeJobLocationWithNameAndParams();
    this.showingConfirmationDialog = false;
  }

  private onDragging(isDragging: boolean) {
    if (!isDragging) {
      this.draggingItemIndex = null;
    }
  }
  private onDraggingItemIndex(index: number | null) {
    this.draggingItemIndex = index;
  }

  private emptyJobData() {
    this.jobTitle = '';
    this.jobCode = '';
    this.jobDescription = '';
    this.jobTriggerFilePath = '';
    this.addedTasks = [];
  }

  private noNotSelectedTask(): boolean {
    const taskBatchNames = this.addedTasks.map(task => task.batchName);
    return R.all(isNotEmptyString, taskBatchNames);
  }

  private allRequiredFieldsFilled(): boolean {
    const mergeTasks = R.lift(getMergeTaskAndMetadata);

    const orderRequiredValueTupleArray = mergeTasks(this.addedTasks);
    const flattenedOrderRequiredValueTupleArray = R.flatten(
      orderRequiredValueTupleArray
    );

    const cond = (item: { order: number; required: string; value: string }) =>
      !R.isNil(item.required) && _BooleanEnum2boolean(item.required as _Boolean) //TODO: Issue #2513
        ? isNotEmptyString(item.value)
        : true;
    return R.all(cond)(flattenedOrderRequiredValueTupleArray);
  }

  private get canSave(): boolean {
    return Boolean(
      this.jobTitle &&
        this.jobCodeRules.every(
          /** NOTE: ruleに反している場合stringが返るためtrueと同値比較する必要がある */
          validationFn => validationFn(this.jobCode || '') === true
        ) &&
        this.addedTasks.length > 0 &&
        this.noNotSelectedTask() &&
        this.allRequiredFieldsFilled() &&
        !this.duplicateOutputPathExist
    );
  }

  private changeIncludeInDownloadIfIsOutputFileFalse(
    tasks: TaskItemForDB[]
  ): void {
    tasks.forEach(task => {
      if (task.includeInDownload === _Boolean._true) {
        const hasOutputFileTrue =
          task.taskMetadata &&
          task.taskMetadata.args &&
          task.taskMetadata.args.some(
            arg => arg.isOutputFile === _Boolean._true
          );
        if (!hasOutputFileTrue) {
          task.includeInDownload = _Boolean._false;
        }
      }
    });
  }

  private async doSave() {
    const result = await getImportJobStatus(
      this.loginInfo.tenant,
      this.loginInfo.landscape
    );
    const progress = result == null ? ImportJobStatus.notStarted : result;

    if (progress === ImportJobStatus.started) {
      globalSnackbarModule.showSnackbarAction(
        i18n.tc('jobScheduler.jobs.importJobAlreadyStarted')
      );
      setTimeout(() => {
        globalSnackbarModule.hideSnackbarAction();
      }, 3000);
      return;
    }
    this.changeIncludeInDownloadIfIsOutputFileFalse(this.addedTasks);
    const jobData = {
      loginInfo: this.loginInfo,
      jobId: this.jobId,
      jobTitle: this.jobTitle,
      jobCode: this.jobCode,
      jobDescription: this.jobDescription,
      jobTriggerFilePath: this.jobTriggerFilePath,
      addedTasks: this.addedTasks,
    };

    if (R.includes('create')(this.$route.fullPath)) {
      await callCreateJob(jobData);
      router.push({
        name: 'job',
        params: { id: this.jobId },
      });
    } else {
      await callUpdateJob(jobData, this.allTaskMetadatas);
    }
    this.copyCurrentDataToDbData();
    this.isSaved = true;
  }

  private async doExecute(): Promise<void> {
    this.doUploadOnExecuteOrNotDialog = false;
    this.executingOverlay = true;
    await executeJobImmediately(
      this.jobId,
      this.loginInfo.loginName,
      EventTriggerType.Immediate,
      this.startFromTheFirstTask
    );
    this.executingOverlay = false;
    this.jobExecutedDialog = true;
  }

  private openUploadOnExecuteDialog(): void {
    this.doUploadOnExecuteOrNotDialog = false;
    BusEvent.$emit(BusEventTargets.UPLOAD_ON_EXECUTE_DIALOG, true);
  }

  private async uploadAndExecute(filesData: UploadFilesData[]) {
    const { tenant, landscape } = this.loginInfo;
    this.uploadingOverlay = true;
    const promises = filesData.map(async fileData => {
      if (fileData.selectedFile) {
        const signedUploadUrl = await generateUploadLink(
          tenant,
          landscape,
          fileData.selectedFile
        );
        await fetch(signedUploadUrl.preSignedUrl, {
          method: 'PUT',
          body: fileData.selectedFile,
        });
        await uploadFilesToIFXAP(
          tenant,
          landscape,
          signedUploadUrl.objectKey,
          fileData.destinationFilePath
        );
      }
    });
    await Promise.all(promises);
    this.uploadingOverlay = false;
    this.doExecute();
  }

  private doCancel(): void {
    if (!this.doesAnyChangeExists()) {
      router.push(PAGE_PATH_BY_NAME.jobs);
      this.jobId = '';
      this.emptyJobData();
      this.selectedJob = null;
      this.showJobDetailArea = false;
    } else {
      this.nextUrl = {
        name: 'jobs',
        params: { id: '' },
      };
      this.showingConfirmationDialog = true;
    }
  }

  @Watch('isSaved')
  doesAnyChangeExists() {
    const inDBData = {
      title: this.selectedJob ? this.selectedJob.title : '',
      jobCode: this.selectedJob ? this.selectedJob.jobCode || '' : '',
      description: this.selectedJob ? this.selectedJob.description : '',
      jobTriggerFilePath: this.selectedJob
        ? this.selectedJob.jobTriggerFilePath
        : '',
      addedTasks: this.selectedJob ? this.selectedJob.tasks.items : [],
    };

    const currentData = {
      title: this.jobTitle,
      jobCode: this.jobCode || '',
      description: this.jobDescription,
      jobTriggerFilePath: this.jobTriggerFilePath,
      addedTasks: this.addedTasks,
    };

    return !R.equals(inDBData, currentData);
  }

  private copyCurrentDataToDbData() {
    const newJobItem = generateJobItem({
      loginInfo: this.loginInfo,
      jobId: this.jobId,
      jobTitle: this.jobTitle,
      jobCode: this.jobCode,
      jobDescription: this.jobDescription,
      jobTriggerFilePath: this.jobTriggerFilePath,
      addedTasks: this.addedTasks,
    });

    const jobIndex = R.findIndex(R.propEq('id', this.jobId))(this.jobs);

    if (jobIndex !== -1) {
      this.jobs = R.update(jobIndex, newJobItem, this.jobs);
    } else {
      this.jobs = R.insert(0, newJobItem, this.jobs);
    }

    this.selectedJob = R.clone(newJobItem);
  }

  private copyDbDataToCurrentData() {
    this.jobTitle = this.selectedJob ? this.selectedJob.title : '';
    this.jobCode = this.selectedJob ? this.selectedJob.jobCode || '' : '';
    this.jobDescription = this.selectedJob ? this.selectedJob.description : '';
    this.jobTriggerFilePath = this.selectedJob
      ? this.selectedJob.jobTriggerFilePath
      : '';
    this.addedTasks = this.selectedJob
      ? R.clone(this.selectedJob.tasks.items)
      : [];
  }

  private initializeJobLocationWithNameAndParams(): JobLocationWithNameAndParams {
    return {
      name: '',
      params: { id: '' },
    };
  }

  private validateIfDuplicateOutputPathExist() {
    const arrayOfOutputFilePath = getArrayOfOutputFilePath(this.addedTasks);
    if (arrayOfOutputFilePath.length <= 1) {
      this.duplicateOutputPathExist = false;
      return;
    }
    this.duplicateOutputPathExist = !isAllUnique(arrayOfOutputFilePath);
  }
}
